export const dealStatuses = {
  InProgress: 1,
  New: 2,
  Approved: 3,
  Rejected: 4
}
